<div class="menu-modal h-full bg-[var(--modal-bg)] text-[var(--modal-text)]" [attr.data-theme]="themeMode">
    <form *ngIf="modalTitle == 'Add Side Menu'" [formGroup]="sideMenuForm" class="menu-modal-form">
        <div class="modal-header">
            <p class="modal-eyebrow">Menu Manager</p>
            <h1>{{modalTitle}}</h1>
        </div>

        <div class="modal-field-grid">
            <mat-form-field appearance="outline">
                <mat-label>Menu Text</mat-label>
                <input matInput type="text" formControlName="ams_side_menu_text">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Menu Order</mat-label>
                <input matInput type="number" formControlName="ams_side_menu_order">
            </mat-form-field>

            <mat-form-field appearance="outline" class="modal-field-span">
                <mat-label>Description</mat-label>
                <input matInput type="text" formControlName="ams_side_menu_description">
            </mat-form-field>
        </div>

        <div *ngIf="errorMessage" class="modal-error">{{errorMessage}}</div>

        <div class="modal-actions">
            <button class="modal-secondary-button" type="button" (click)="closeModal()">Close</button>
            <button class="modal-primary-button" (click)="addNewSideMenu()" type="button" [disabled]="saving">
                {{ saving ? 'Saving...' : 'Add' }}
            </button>
        </div>
    </form>

    <form *ngIf="modalTitle == 'Add Side Sub Menu'" [formGroup]="sideSubMenuForm" class="menu-modal-form">
        <div class="modal-header">
            <p class="modal-eyebrow">Menu Manager</p>
            <h1>{{modalTitle}}</h1>
        </div>

        <div class="modal-field-grid">
            <mat-form-field appearance="outline" class="modal-field-span">
                <mat-label>Parent</mat-label>
                <mat-select formControlName="ams_side_menu_id">
                    <mat-option *ngFor="let item of parentSubMenu" [value]="item.id">{{item.text}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Menu Text</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_menu_text">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Menu Page</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_menu_page">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Icon</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_menu_icon">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Menu Order</mat-label>
                <input matInput type="number" formControlName="ams_side_sub_menu_order">
            </mat-form-field>

            <div class="modal-checkbox-row modal-field-span">
                <mat-checkbox formControlName="ams_side_sub_sub_menu">Has child menu items</mat-checkbox>
            </div>

            <mat-form-field appearance="outline" class="modal-field-span">
                <mat-label>Description</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_menu_description">
            </mat-form-field>
        </div>

        <div *ngIf="errorMessage" class="modal-error">{{errorMessage}}</div>

        <div class="modal-actions">
            <button class="modal-secondary-button" type="button" (click)="closeModal()">Close</button>
            <button class="modal-primary-button" (click)="addNewSideSubMenu()" type="button" [disabled]="saving">
                {{ saving ? 'Saving...' : 'Add' }}
            </button>
        </div>
    </form>

    <form *ngIf="modalTitle == 'Add Side Sub Sub Menu'" [formGroup]="sideSubSubMenuForm" class="menu-modal-form">
        <div class="modal-header">
            <p class="modal-eyebrow">Menu Manager</p>
            <h1>{{modalTitle}}</h1>
        </div>

        <div class="modal-field-grid">
            <mat-form-field appearance="outline" class="modal-field-span">
                <mat-label>Parent</mat-label>
                <mat-select formControlName="ams_side_sub_menu_id">
                    <mat-option *ngFor="let item of parentSubSubMenu" [value]="item.id">{{item.text}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Sub Menu Text</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_sub_menu_text">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Sub Menu Page</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_sub_menu_page">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Icon</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_sub_menu_icon">
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Sub Sub Menu Order</mat-label>
                <input matInput type="number" formControlName="ams_side_sub_sub_menu_order">
            </mat-form-field>

            <mat-form-field appearance="outline" class="modal-field-span">
                <mat-label>Description</mat-label>
                <input matInput type="text" formControlName="ams_side_sub_sub_menu_description">
            </mat-form-field>
        </div>

        <div *ngIf="errorMessage" class="modal-error">{{errorMessage}}</div>

        <div class="modal-actions">
            <button class="modal-secondary-button" type="button" (click)="closeModal()">Close</button>
            <button class="modal-primary-button" (click)="addNewSideSubSubMenu()" type="button" [disabled]="saving">
                {{ saving ? 'Saving...' : 'Add' }}
            </button>
        </div>
    </form>
</div>
